(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.show_more = {
    attach: function(context, settings) {
      // let $show_more_triggers = $('.show-more-trigger');
      // let $show_more_containers = $('.show-more-wrap');
      $('.show-more-trigger').once('expand-show-more').on('click', function() {
        $(this).toggleClass('expanded');
        $(this).prev('.show-more-wrap').toggleClass('expanded');
      });

      $('#keyword-param').text($('#param').text());

      // mutation observer
      $('.form-item-oe-membership-type select', context).once('oe-select-handler').on('change', function() {
        if ($(this).val() === '11945') {
          $('.form-item-oe-sales-volume select', context).val('11959');
        }
      });
    }
  };
})(jQuery, Drupal, once);
